export const BASE_ASSET_URL_PROD = 'https://app.notablehealth.com/asset/previsit' as const;
export const BASE_ASSET_URL_DEV =
  'https://storage.googleapis.com/vivaa-dev-assets/asset/previsit' as const;

export function getBaseAssetUrl(): string {
  return isLocalDevelopmentHostname() ? BASE_ASSET_URL_DEV : BASE_ASSET_URL_PROD;
}

export function getLoginUrl(): string {
  return `${getBaseStaffUrl()}/login`;
}

export function isLocalDevelopmentHostname(): boolean {
  return (
    window.location.hostname === 'localhost' ||
    window.location.hostname.endsWith('.localhost') ||
    window.location.hostname === '127.0.0.1'
  );
}

export function getBaseStaffUrl(): string {
  return isLocalDevelopmentHostname()
    ? `http://${window.location.hostname}:3002/staff/app#`
    : `${window.location.origin}/staff/app#`;
}

export function getBaseAdminUrl(): string {
  return isLocalDevelopmentHostname()
    ? `http://${window.location.hostname}:3001/admin/app#`
    : `${window.location.origin}/admin/app#`;
}
